export default {
  title: 'Dit eget domæne',
  description:
    'Kør dit teams apps på et domæne, du selv ejer, i stedet for den delte adresse. Forbind domænet én gang: Dashboardet, ordreportalen, websiteeditoren og website studio får hver en adresse under det.',
  read_only_description: 'Det domæne, denne partner kører sine apps på. Kun partneren kan forbinde eller frakoble det.',
  read_only_empty: 'Denne partner har ikke forbundet et domæne.',
  not_connected: {
    label: 'Domæne',
    hint: 'Det domæne, du ejer, uden www – for eksempel yourbrand.com. Derefter tilføjer du de DNS-poster, vi viser dig, hos din domæneudbyder.',
    placeholder: 'yourbrand.com',
    connect: 'Forbind',
  },
  apps: {
    dashboard: 'Dashboard',
    oms: 'Ordreportal',
    storefront: 'Websiteeditor',
    website_studio: 'Website studio',
  },
  status: {
    active: 'Live',
    pending: 'Venter på DNS',
    failed: 'Kræver opmærksomhed',
    disabled: 'Frakoblet',
  },
  records: {
    title: 'Tilføj disse DNS-poster for {{root}} hos din domæneudbyder',
  },
  instructions: {
    title: 'Sådan tilføjer du posterne',
    step_provider:
      'Log ind der, hvor DNS for {{root}} administreres – normalt hos det firma, du købte domænet af, eller hos en DNS-host som Cloudflare.',
    step_add:
      'Åbn DNS-indstillingerne for {{root}}, og tilføj hver post nedenfor: Vælg typen, og kopier derefter navn og værdi nøjagtigt. Lad TTL stå på standardværdien.',
    step_check:
      'Gem posterne, og klik derefter på „{{button}}“. De fleste udbydere udgiver ændringer inden for få minutter; nogle bruger op til 48 timer.',
    tip_name:
      'I navnefeltet vil de fleste udbydere kun have den del, der står før {{root}}, vist med fed skrift. Hvis din udbyder beder om det fulde navn, så kopier det, der står nedenunder.',
    tip_cloudflare:
      'På Cloudflare skal du sætte CNAME-posterne til „Kun DNS“ (grå sky). En proxy-post skjuler CNAME’en, så domænet ikke kan verificeres.',
    tip_existing:
      'Lad dine eksisterende poster for {{root}} og www stå uændrede – din hjemmeside fortsætter med at virke.',
  },
  summary: {
    live: 'Dit dashboard er live på {{host}}.',
    pending: 'Vi tjekker dine DNS-poster jævnligt. Det kan tage op til 48 timer, før nye poster bliver fundet.',
    failed: 'Nogle poster kunne ikke verificeres. Ret de poster, der er markeret nedenfor, og tjek igen.',
    relogin: 'Når {{host}} er live, logger dit team ind der. Det første besøg beder dem om at logge ind igen.',
  },
  buttons: {
    check_again: 'Tjek igen',
    disconnect: 'Frakobl',
    retry: 'Prøv igen',
  },
  disconnect_confirm: {
    title: 'Frakobl {{root}}?',
    description: 'Dine apps vender tilbage til den delte adresse, og links på {{root}} holder op med at virke.',
    ok: 'Frakobl',
  },
  toasts: {
    load_error: 'Kunne ikke indlæse dit domæne.',
    load_error_read_only: 'Kunne ikke indlæse denne partners domæne.',
    connected: 'Domænet er forbundet. Tilføj DNS-posterne nedenfor.',
    connect_failed: 'Kunne ikke forbinde domænet.',
    check_started: 'Tjekker dine DNS-poster.',
    check_failed: 'Kunne ikke starte et tjek. Prøv igen om lidt.',
    disconnected: 'Domænet er frakoblet.',
    disconnect_failed: 'Kunne ikke frakoble domænet.',
  },
};
